module.exports = __webpack_public_path__ + "static/img/agent-section-2-page-background.101b322.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/agent-section-2-page-background.png
// module id = 8EIP
// module chunks = 1